<div class="cc-modal">
  <header class="cc-modal-h">
    <h2 class="cc-modal-title">{{ title }}</h2>
    <button class="cc-modal-close" (click)="onCancel()" aria-label="Close" type="button">
      <svg viewBox="0 0 14 14" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">
        <line x1="3" y1="3" x2="11" y2="11"/>
        <line x1="11" y1="3" x2="3" y2="11"/>
      </svg>
    </button>
  </header>

  <div class="cc-modal-body">
    @if (loading) {
      <div class="cc-section cc-empty">
        <span class="cc-spinner"></span>
        <p>Loading…</p>
      </div>
    } @else if (modules?.length) {
      <div class="cc-section cc-section--trigger">
        <button #triggerEl type="button" class="ss-trigger" [class.ss-trigger--open]="open" (click)="togglePanel()">
          <span class="ss-trigger-text" [class.ss-trigger-text--placeholder]="!hasSelection()">{{ triggerText() }}</span>
          <svg class="ss-trigger-chev" [class.ss-trigger-chev--open]="open" width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M6 9 L12 15 L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>

      @if (showSelectedChips()) {
        <div class="cc-section cc-section--chips">
          <div class="ss-chips">
            @for (m of selectionAsArray(); track m?._id) {
              <span class="ss-chip">
                <span class="ss-chip-label">{{ m?.label }}</span>
                <button type="button" class="ss-chip-x" (click)="removeFromSelection(m, $event)" aria-label="Remove">×</button>
              </span>
            }
          </div>
        </div>
      }
    } @else {
      <div class="cc-section cc-empty">
        <p>No types available</p>
      </div>
    }
  </div>

  <footer class="cc-modal-foot">
    <span></span>
    <div class="cc-foot-actions">
      <button type="button" class="cc-btn-secondary" (click)="onCancel()">Cancel</button>
      <button type="button" class="cc-btn-primary" (click)="onConfirm()" [disabled]="!hasSelection()">
        Select{{ selectButtonSuffix() }}
      </button>
    </div>
  </footer>
</div>

<ng-template #panelTemplate>
  <div class="ss-panel">
    @if (modules.length > 1) {
      <div class="ss-search">
        <input #searchInput
          type="text"
          class="ss-search-input"
          placeholder="Search…"
          [(ngModel)]="searchTerm"
          (input)="applySearchFilter()"
          [ngModelOptions]="{ standalone: true }">
      </div>
    }
    <div class="ss-options">
      @for (m of modules; track m?._id) {
        <div class="ss-option"
          [class.ss-option--hidden]="hiddenIndices.has($index)"
          [class.ss-option--selected]="isSelected(m)"
          (click)="onOptionClick(m, $event)">
          @if (multiSelect) {
            <span class="ss-option-check">
              @if (isSelected(m)) {
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M5 12 L10 17 L19 7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              }
            </span>
          }
          <span class="ss-option-label">{{ m?.label }}</span>
          @if (!multiSelect && isSelected(m)) {
            <svg class="ss-option-single-check" width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M5 12 L10 17 L19 7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          }
        </div>
      }
      @if (allHiddenByFilter()) {
        <div class="ss-empty-row">No matches</div>
      }
    </div>
  </div>
</ng-template>